import React from 'react';
import {
  useNavigate,
  useLocation,
} from "react-router-dom";
import { FaPen, FaExternalLinkAlt } from "react-icons/fa";
import ResponsiveTable  from "./../../ResponsiveTable";
import {OverviewSubheader} from "./../../layouts";
import {
  useOfferUpdatesList,
} from "../../../queries/offer_updates";
import {
  formatDateWithoutTimezone
} from "./../../../utils/datetime";
import {
  Buttons,
} from "./../../../components";

export default function List({ offerId, canEdit }) {
  const navigate = useNavigate();
  const location = useLocation();
  const {data:offerUpdates, isLoading, error} = useOfferUpdatesList({offer_id: offerId})

  const openEditorModal = React.useCallback(
    (action, offerUpdate) => {
      navigate(
        action === "edit" ? `updates/${offerUpdate.id}/edit` : `updates/new`,
        {
          state: {
            backgroundLocation: location
          }
        }
      )
    },
    [navigate, location]
  )

  if(isLoading)
    return "Loading offer updates...";

  const columns = [
    {
      Header: 'Title',
      accessor: 'title'
    },
    {
      Header: 'Date posted',
      accessor: 'published_at',
      Cell: ({value}) => formatDateWithoutTimezone(value)
    },
    {
      Header: 'Likes',
      accessor: 'likes_count'
    },
    {
      Header: 'Comments',
      accessor: 'discussions_count'
    },
    {
      Header: 'Type',
      Cell: ({value, row}) => {
        return row.original.resourceable_type ? 'Live Event' : 'Offer Update';
      }
    },
    {
      Header: 'Status',
      accessor: 'status'
    },
    {
      Header: '',
      accessor: 'id',
      Cell: ({value, row}) => (
       canEdit && !row.original.resourceable_type && row.original.status !== "approved"
          ? <div className="table-action-items-container justify-content-end">
              <button
                  className="btn btn-sm p-0 ps-2 action-item cursor-pointer"
                  onClick={ () => openEditorModal("edit", row.original) }
                >
                  <FaPen className='fs-14 color-black'/>
                </button>
            </div>
          : <div className="table-action-items-container justify-content-end">
              <button
                  className="btn btn-sm p-0 ps-2 action-item cursor-pointer"
                  onClick={() => window.open(`${process.env.REACT_APP_INVESTOR_APP_URL}/offers/${offerId}/updates/${row.original.id}`, "_blank") }
                >
                  <FaExternalLinkAlt className='fs-14 color-black'/>
                </button>
            </div>
      )
    }
  ];



  if(error){
    return <div className='text-center text-danger montserrat weight-500 fs-8 mt-4'>Something went wrong please try again after some time.</div>
  }

  return(
    <>
      <OverviewSubheader left='Offer Updates' right={canEdit && <Buttons.TextButton title='New Offer Update' onClick={ () => openEditorModal("new") } /> } tooltipDesc="Issuers can use the Updates feature to communicate with their community of investors on Spaced Ventures. When a new Update is posted, a notice is sent out to all current investors in your offer and all followers of your company." />
      <ResponsiveTable title="Updates" columns={columns} data={offerUpdates}/>
    </>
  );
}
